var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLeftQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91241 24.032C4.14441 24.032 3.44041 23.712 2.80041 23.072C2.20307 22.3893 1.71241 21.5147 1.32841 20.448C0.987073 19.3387 0.816406 18.1653 0.816406 16.928C0.816406 14.8373 1.22174 12.5333 2.03241 10.016C2.88574 7.45599 4.08041 5.15199 5.61641 3.10399C6.46974 1.86666 7.25907 1.05599 7.98441 0.671993C8.70974 0.287993 9.54174 0.095993 10.4804 0.095993C11.4191 0.095993 12.2084 0.351994 12.8484 0.863995C13.5311 1.37599 14.0644 2.01599 14.4484 2.78399C14.8324 3.50933 15.0244 4.25599 15.0244 5.02399C15.0244 5.53599 14.9177 6.04799 14.7044 6.55999C14.5337 7.07199 14.1497 7.712 13.5524 8.48C12.0591 10.3147 10.9497 12.1493 10.2244 13.984C9.49907 15.776 8.94441 17.5467 8.56041 19.296C8.21907 20.96 7.77107 22.176 7.21641 22.944C6.66174 23.6693 5.89374 24.032 4.91241 24.032ZM21.7444 27.296C20.9337 27.296 20.2084 26.976 19.5684 26.336C18.9711 25.6533 18.5017 24.7787 18.1604 23.712C17.8191 22.6453 17.6484 21.4933 17.6484 20.256C17.6484 18.6347 17.9044 16.8213 18.4164 14.816C18.9711 12.768 19.7817 10.976 20.8484 9.43999C21.7017 8.24533 22.5124 7.45599 23.2804 7.07199C24.0484 6.64533 24.9017 6.432 25.8404 6.432C26.7791 6.432 27.5897 6.66666 28.2724 7.13599C28.9977 7.56266 29.5524 8.13866 29.9364 8.86399C30.3204 9.54666 30.5124 10.208 30.5124 10.848C30.5124 11.4453 30.3844 12.0427 30.1284 12.64C29.8724 13.1947 29.4244 13.8987 28.7844 14.752C27.7177 16.1173 26.9284 17.44 26.4164 18.72C25.9471 20 25.5631 21.28 25.2644 22.56C24.9657 24.1813 24.5391 25.376 23.9844 26.144C23.4297 26.912 22.6831 27.296 21.7444 27.296Z",
    fill: "#9747FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuote);
export default __webpack_public_path__ + "static/media/left_quote.476fce21.svg";
export { ForwardRef as ReactComponent };